import { createContext } from 'react';
const FormControlContext = createContext({
    updateForm() { },
});
export default FormControlContext;
